import { render, staticRenderFns } from "./LoginRedirect.vue?vue&type=template&id=784587d6&scoped=true&"
import script from "./LoginRedirect.vue?vue&type=script&lang=js&"
export * from "./LoginRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784587d6",
  null
  
)

export default component.exports